import { ACCESS_TOKEN, REFRESH_TOKEN } from "@/constants/common";
import {
  deleteCookie,
  getCookie as getCookieNext,
  OptionsType,
  setCookie,
} from "cookies-next";
import { jwtDecode } from "jwt-decode";
import Cookies from "universal-cookie";

export const cookies = new Cookies(null, { path: "/" });

export const getCookieSSR = (key: string, options?: OptionsType): string => {
  //@ts-expect-error
  return getCookieNext(key, { path: "/", ...options });
};

export const deleteCookieSSR = (key: string, options?: OptionsType) => {
  deleteCookie(key, { path: "/", ...options });
};

export const setCookieSSR = (
  key: string,
  value: any,
  options?: OptionsType,
  exp?: number
) => {
  const stringValue =
    typeof value === "string" ? value : JSON.stringify(value ?? "");
  if (stringValue.length > 3800) {
    console.warn(
      `[setCookieSSR] cookie "${key}" too large (${stringValue.length} chars). Not setting cookie.`
    );
    return;
  }
  const timeNow = new Date().getTime();
  const shortExp = timeNow + 120 * 24 * 3600 * 1000; // 120 day
  const expires = exp ? new Date(exp * 1000) : new Date(shortExp);

  setCookie(key, value, {
    path: "/",
    expires,
    ...options,
  });
};

export const getTokenExpires = (token: string) => {
  const { exp } = jwtDecode<{ exp: number }>(token);
  const timeNow = new Date().getTime();
  const shortExp = timeNow + 5 * 3600 * 1000; // 5 hours

  const expires = exp ? new Date(exp * 1000) : new Date(shortExp);

  return expires;
};

export const getRefreshTokenExpires = () => {
  const timeNow = new Date().getTime();
  const shortExp = timeNow + 90 * 24 * 3600 * 1000; // 90 days

  return new Date(shortExp);
};

export const setTokenCookiesSSR = (
  token: string,
  option?: Partial<OptionsType>
) => {
  setCookie(ACCESS_TOKEN, token, {
    path: "/",
    expires: getTokenExpires(token),
    ...option,
  });
};

export const setRefreshTokenCookiesSSR = (
  token: string,
  option?: Partial<OptionsType>
) => {
  setCookie(REFRESH_TOKEN, token, {
    path: "/",
    expires: getRefreshTokenExpires(),
    ...option,
  });
};

export const verifyJwtToken = (token: string) => {
  return jwtDecode<{ exp: number }>(token).exp < Date.now() / 1000;
};

export const renderUrLoginGoogle = (page: string): Location => {
  //@ts-expect-error
  return `https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?redirect_uri=${process.env.NEXT_PUBLIC_BASE_URL}${page}&scope=email%20profile%20openid&openid.realm&include_granted_scopes=true&response_type=token&client_id=45701807038-i6eecejo5d338deeqijd8doirs5soviu.apps.googleusercontent.com&ss_domain=${process.env.NEXT_PUBLIC_BASE_URL}&prompt&fetch_basic_profile=true&gsiwebsdk=2&service=lso&o2v=1&theme=mn&ddm=0&flowName=GeneralOAuthFlow`;
};
